import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/** Renders a scannable QR image for a value (dark-on-white for contrast). */
export function QrImage({
  value,
  size = 160,
  className,
}: {
  value: string;
  size?: number;
  className?: string;
}): React.JSX.Element {
  const [dataUrl, setDataUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!value) {
      setDataUrl(null);
      return;
    }
    let cancelled = false;
    void QRCode.toDataURL(value, { width: size, margin: 1 }).then((url) => {
      if (!cancelled) setDataUrl(url);
    });
    return () => {
      cancelled = true;
    };
  }, [value, size]);

  if (!dataUrl) {
    return (
      <div
        className={className}
        style={{ width: size, height: size }}
        aria-label="Generating QR code"
      />
    );
  }
  return <img src={dataUrl} alt="QR code" width={size} height={size} className={className} />;
}
